module.exports = __webpack_public_path__ + "img/pic-01.58725959.png";